import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type { WrappedValue } from '../mailgun/wrap-value';
import { wrapValue } from '../mailgun/wrap-value';

@Pipe({
  name: 'mailgunMarkAsHtml',
  standalone: true,
})
export class MailgunMarkAsHtmlPipe implements PipeTransform {
  public transform(value: WrappedValue<any>): any {
    return wrapValue(value.toPath(), value.toValue(), {
      asHtml: true,
      ...value.getOpts(),
    });
  }
}
